export const SET_BUSINESS_SCOPE_KASSE_DISCOUNTS = 'SET_BUSINESS_SCOPE_KASSE_DISCOUNTS'
export const SET_BUSINESS_SCOPE_SHOP_DISCOUNTS = 'SET_BUSINESS_SCOPE_SHOP_DISCOUNTS'
export const SET_BUSINESS_SCOPE_USE_SHOP_DISCOUNT = 'SET_BUSINESS_SCOPE_USE_SHOP_DISCOUNT'
export const SET_BUSINESS_SCOPE_LAST_SAVED_DISCOUNT = 'SET_BUSINESS_SCOPE_LAST_SAVED_DISCOUNT'
export const SET_BUSINESS_SCOPE_CURRENT_CHANGED_DISCOUNT = 'SET_BUSINESS_SCOPE_CURRENT_CHANGED_DISCOUNT'
